// extracted by mini-css-extract-plugin
export default {"fullWidth":"mp-z","image":"np-z","lazyLoadPicture":"op-z","lazyLoadSpinner":"pp-z","lazyLoadSpin":"qp-z","lazyLoadImage":"rp-z","hasStyledAspectRatio":"sp-z"};